import { Box } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from 'src/context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { DisplayEuroMUI } from 'src/utils/formats';
import { enumT } from 'src/utils/helper';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const PersonalkostenAntragKreativwirtschaftUebersicht: FC<{}> = () => {
	const { application } = useApplication();
	const columns = useMemo(() => {
		let column = [
			// { field: 'id', headerName: 'ID', width: 80, groupable: false },
			{ field: 'name', headerName: 'Name', flex: 1, groupable: false },
			{ field: 'funktion', headerName: 'Funktion im Vorhaben', flex: 1, groupable: false },
			{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
			{
				field: 'geplanteSumme',
				headerName: 'Geplante Summe',
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return DisplayEuroMUI(value);
				},
			},
		];

		return column;
	}, []);

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten)
			.map((ele: any) => {
				return {
					id: get(ele, 'id'),
					name: get(ele, KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Name_Desder_Beschaeftigten.path),
					funktion: get(ele, KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Funktion_Im_Beantragten_Vorhaben.path, ''),
					kostenart: get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path),
					kostenKategorie: enumT(
						get(ele, KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path, ''),
					),
					geplanteSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					geplanteSumme: 'sum',
				},
			},
		};
	}, [application]);

	return (
		<Box sx={{ height: 'auto', width: '100%' }}>
			<ApplicationHeading title='Personalkosten Übersicht' description={PLATZHALTER_TEXT} />
			<DataGridPremium
				rows={rows}
				columns={columns}
				initialState={initialState}
				hideFooter
				disableRowSelectionOnClick
				localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
			/>
		</Box>
	);
};
export default PersonalkostenAntragKreativwirtschaftUebersicht;
